<div ngModelGroup="address">
    <div [grid]="4"
         [gridColumnGap]="'16px'"
         [gridRowGap]="'16px'">
        @if(displayAddress){

        <form-mui-field [label]="('Address'| translate)"
                        [gridColumn]="isSM ? 4 : 2">
            <input type="text"
                   name="street_1"
                   cy-addressAddFirstLine
                   customform-google-maps-address-autocomplete
                   [country]="data.country_id"
                   [(ngModel)]="data.street_1"
                   autocomplete="address-line1"
                   required>
        </form-mui-field>
        }

        @if(displayCountry){

        <form-mui-field [label]="('Country'| translate)"
                        [gridColumn]="isSM ? 4 : 2">
            <select name="country"
                    autocomplete="country"
                    cy-addressAddCountry
                    [(ngModel)]="data.country_id"
                    (change)="onCountryChange()"
                    required>
                @for (country of countries | orderBy: ['name']; track country.code) {
                <option [value]="country.code">{{country.name| translate}}</option>
                }
            </select>
        </form-mui-field>
        }

        @if(displayCity){

        <form-mui-field [label]="('City'| translate)"
                        [gridColumn]="isSM ? 4 : 2">
            <input type="text"
                   name="city"
                   cy-addressAddCity
                   autocomplete="address-level2 address-level3 address-level4"
                   [(ngModel)]="data.city"
                   required>
        </form-mui-field>
        }

        <!--Region-->
        @if (displayRegion) {
        @if (!regions) {
        <form-mui-field [label]="('State'| translate)"
                        [gridColumn]="isSM ? 2 : 1"
                        [hideSideIcon]="!regionRequired">
            <input type="text"
                   name="region"
                   cy-addressAddRegion
                   [(ngModel)]="data.region"
                   autocomplete="address-level1"
                   [required]="regionRequired">
        </form-mui-field>
        }
        @if (regions) {
        <form-mui-field [label]="('State'| translate)"
                        [gridColumn]="isSM ? 2 : 1"
                        [hideSideIcon]="!regionRequired">
            <select name="region_id"
                    cy-addressAddRegionId
                    [(ngModel)]="data.region_id"
                    autocomplete="address-level1"
                    [required]="regionRequired">
                <option value=""></option>
                @for (region of regions | orderBy: ['name']; track region.id) {
                <option [value]="region.id">{{region.name}}</option>
                }
            </select>
        </form-mui-field>
        }
        }

        @if(displayPostcode){

        <form-mui-field [label]="('Zip Code'| translate)"
                        [gridColumn]="isSM ? 2 : 1">
            <input type="text"
                   name="postcode"
                   cy-addressAddPostcode
                   autocomplete="postal-code"
                   [(ngModel)]="data.postcode"
                   required>
        </form-mui-field>
        }

    </div>

</div>